import { useState } from "react";
import { cn } from "@/lib/utils";
import type { DateRangeKey } from "./dashboard-helpers";

interface Props {
  active: DateRangeKey;
  onChange: (key: DateRangeKey) => void;
}

const PRESETS: { key: DateRangeKey; label: string }[] = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "thisMonth", label: "This Month" },
  { key: "lastMonth", label: "Last Month" },
  { key: "custom", label: "Custom Date" },
];

export function DateRangeFilter({ active, onChange }: Props) {
  const [start, setStart] = useState<string>("");
  const [end, setEnd] = useState<string>("");

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-range-filter">
      <div className="inline-flex items-center rounded-full border border-border bg-muted/30 p-1">
        {PRESETS.map((preset) => {
          const isActive = preset.key === active;
          return (
            <button
              key={preset.key}
              type="button"
              onClick={() => onChange(preset.key)}
              className={cn(
                "px-3 py-1.5 text-xs font-medium rounded-full transition-colors cursor-pointer",
                isActive
                  ? "bg-card text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground"
              )}
              data-testid={`date-range-${preset.key}`}
            >
              {preset.label}
            </button>
          );
        })}
      </div>
      {active === "custom" && (
        <div className="flex items-center gap-2 text-sm">
          <input
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
            className="px-3 py-1.5 border border-border rounded-md text-xs bg-card"
            data-testid="date-range-start"
          />
          <span className="text-xs text-muted-foreground">to</span>
          <input
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
            className="px-3 py-1.5 border border-border rounded-md text-xs bg-card"
            data-testid="date-range-end"
          />
        </div>
      )}
    </div>
  );
}
